import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { withLocalize } from "react-localize-redux";
import TextWithIcon from "../Shared/TextWithIcon";
import PauseCircleOutlineOutlined from "../../Assets/Images/pause_circle_outlined.svg";
import CancelCircleOutlined from "../../Assets/Images/cancel_circle_outlined.svg";
import QuestionAnswer from "../../Assets/Images/question_answer.svg";
import StickyNoteOutlined from "../../Assets/Images/sticky_note_outlined.svg";
import { ArrowBack } from "@material-ui/icons";
import CreditCard from "../../Assets/Images/credit_card.svg";
import SoothePassMembershipCard from "./SoothePassMembershipCard";
import PauseMembership from "./PauseMembership";
import CancelMembership from "./CancelMembership";
import ChangePlan from "./ChangePlan";
import FAQ from "./FAQ";
import ChangePaymentMethod from "./ChangePaymentMethod";

class SoothePassMembershipView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "main", // 'main', 'pause', 'cancel', 'payment', 'faq'
      openedIndex: null,
      width: window.innerWidth,
      flag: false,
    };
  }
  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
  }

  setView = (view) => {
    this.setState({ view });
  };

  mainOptions = () => {
    const status = get(this.props, "client.soothe_pass.state", "");

    return (
      <div>
        {/* TODO change resume ui to match design */}
        {status === "paused" || status === "paused_pending" ? (
          <div
            className="clickable cursor-pointer"
            onClick={() => this.setView("pause")}
          >
            <TextWithIcon
              icon={PauseCircleOutlineOutlined}
              title={"Resume membership"}
              displayBorder={true}
              displayArrow={true}
            />
          </div>
        ) : null}
        <div
          className="clickable cursor-pointer"
          onClick={() => this.setView("changePlan")}
        >
          <TextWithIcon
            icon={StickyNoteOutlined}
            title={"Change plan"}
            displayBorder={true}
            displayArrow={true}
          />
        </div>
        <div
          className="clickable cursor-pointer"
          onClick={() => this.setView("payment")}
        >
          <TextWithIcon
            icon={CreditCard}
            title={"Change payment method"}
            displayBorder={true}
            displayArrow={true}
          />
        </div>
        {status === "paused" || status === "paused_pending" ? null : (
          <div
            className="clickable cursor-pointer"
            onClick={() => this.setView("pause")}
          >
            <TextWithIcon
              icon={PauseCircleOutlineOutlined}
              title={"Pause membership"}
              displayBorder={true}
              displayArrow={true}
            />
          </div>
        )}
        {status === "cancel" ? null : (
          <div
            className="clickable cursor-pointer"
            onClick={() => this.setView("pauseSuggestion")}
          >
            <TextWithIcon
              icon={CancelCircleOutlined}
              title={"Cancel membership"}
              displayBorder={true}
              displayArrow={true}
            />
          </div>
        )}
        <div
          className="clickable cursor-pointer"
          onClick={() => this.setView("faq")}
        >
          <TextWithIcon
            icon={QuestionAnswer}
            title={"FAQs"}
            displayArrow={true}
          />
        </div>
      </div>
    );
  };
  paymentOptions = () => {
    return (
      <ChangePaymentMethod
        handleBack={(flag) => {
          this.setView("main");
          if (flag) {
            window.location.reload();
          }
        }}
      />
    );
  };
  changePlanOptions = () => {
    return (
      <ChangePlan
        handleBack={(flag) => {
          this.setView("main");
          if (flag) {
            window.location.reload();
          }
        }}
      />
    );
  };
  pauseOptions = () => {
    const { view } = this.state;
    return (
      <div>
        <PauseMembership
          handleBack={(flag) => {
            this.setView("main");
            if (flag) {
              window.location.reload();
            }
          }}
          comingFromCancel={view === "pauseSuggestion"}
          cancelInstead={() => this.setView("cancel")}
          openFAQ={(flag) => {
            this.setView("faq");
            this.setState({ flag });
          }}
        />
      </div>
    );
  };

  cancelOptions = () => {
    return (
      <div>
        <CancelMembership
          handleBack={(flag) => {
            this.setView("main");
            if (flag) {
              window.location.reload();
            }
          }}
          client={this.props.client}
        />
      </div>
    );
  };
  faqOptions = () => {
    const { flag } = this.state;
    return (
      <div>
        <div
          className="cursor-pointer mb-14"
          onClick={() => {
            this.setView("main");
            if (flag) {
              window.location.reload();
            }
          }}
          role="button"
          tabIndex={0}
          onKeyDown={() => {
            this.setView("main");
            if (flag) {
              window.location.reload();
            }
          }}
        >
          <ArrowBack className="w-h-20-imp BlackBlueish" />
        </div>
        <FAQ />
      </div>
    );
  };
  cancelPendingView = () => {
    const subscription_next_charge_date_only = get(
      this.props,
      "client.soothe_pass.subscription_next_charge_date_only",
      ""
    );
    const { width } = this.state;
    return (
      <div className="col-xs-12 col-md-8">
        <div
          className={
            width >= 800 ? "br-rd-12 bg-primary p-24" : "bg-primary sm-p-24-16"
          }
        >
          <div className="contentPrimary">
            <div className="size-24-32 font-weight-bold mb-16">
              Your membership is pending cancellation
            </div>
            <div className="size-16-24 mb-16">
              Your unused points will remain on your account until they expire
              and disappear on: {subscription_next_charge_date_only}
            </div>
            <div className="mb-24">
              <button
                className="btn cta-tertiary p-10-12-imp size-14-16-imp"
                onClick={this.props.openFAQ}
                type="button"
                style={{ width: "auto" }}
              >
                Explore FAQ
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  resumeOption = () => {
    return (
      <div>
        <div
          className="clickable cursor-pointer mb-14"
          onClick={() => this.setView("main")}
          role="button"
          tabIndex={0}
          onKeyDown={() => this.setView("main")}
        >
          <ArrowBack className="w-h-20-imp BlackBlueish" />
        </div>
        <div className="size-24-32 contentPrimary font-weight-bold mb-16">
          Resume Membership
        </div>
        <div className="size-16-24 contentSecondary mb-16">
          Your SoothePass membership is currently paused. You can resume it at
          any time.
        </div>
        <div className="mb-24">
          <button
            className="btn cta-tertiary p-10-12-imp size-14-16-imp"
            onClick={() => this.setView("main")}
            type="button"
            style={{ width: "auto" }}
          >
            Done
          </button>
        </div>
        <button
          type="button"
          className="btn md-cta-primary p-10-12-imp"
          // onClick={this.handlePauseMembership}
          // disabled={isLoading}
          style={{ width: "auto" }}
        >
          {this.state.isLoading ? "Pausing..." : "Pause membership"}
        </button>
        {/* <CTAButton
                    text="Resume Membership Now"
                    action={() => this.setView('main')}
                    additionalClass="resp-w-303 size-14-16-imp p-10-12-imp"
                    additionalWrapperClass="justify-content-center"
                /> */}
      </div>
    );
  };

  render() {
    const { view, width } = this.state;
    const state = get(this.props, "client.soothe_pass.state", "");
    const paymentDeclined = get(
      this.props,
      "client.soothe_pass.needs_attention",
      false
    );
    const nextChargeDate = get(
      this.props,
      "client.soothe_pass.subscription_next_charge_date_only",
      ""
    );
    return (
      <div className={width >= 800 ? "row" : ""}>
        {paymentDeclined && (
          <div style={{ width: "100%", marginBottom: 24 }}>
            <div
              style={{
                background: "#E11900",
                borderRadius: 8,
                padding: 16,
                display: "flex",
                alignItems: "center",
                gap: 16,
                alignSelf: "stretch"
              }}
            >
              <div
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: 16,
                  lineHeight: "1.25em",
                  color: "#FFFFFF",
                  textAlign: "left",
                  flex: 1
                }}
              >
                Your payment was declined. Your subscription will be suspended
                on {nextChargeDate} if unresolved.
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 0px"
                }}
              >
                <div
                  style={{
                    background: "#FFEFED",
                    borderRadius: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                    padding: "10px 12px",
                    cursor: "pointer"
                  }}
                  onClick={() => this.setView("payment")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      this.setView("payment");
                    }
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: 14,
                      lineHeight: "1.1428571428571428em",
                      color: "#C11500",
                      textAlign: "center"
                    }}
                  >
                    Update Now 
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={width >= 800 ? "col-md-4" : ""}>
          <div className="br-rd-12 bg-primary p-24 mr-24 h-100 mb-24 sm-m-16-16-22 sm-p-24-16">
            <SoothePassMembershipCard {...this.props} />
          </div>
        </div>
        {state === "cancel_pending" ? (
          this.cancelPendingView()
        ) : (
          <div className={width >= 800 ? "col-md-8" : ""}>
            <div
              className={
                width >= 800
                  ? `br-rd-12 bg-primary ${view === "changePlan" ? "" : "p-24"}`
                  : `bg-primary ${view === "changePlan" ? "" : "sm-p-24-16"}`
              }
            >
              {view === "main" && this.mainOptions()}
              {/* {view === 'resume' && this.resumeOption()} */}
              {view === "changePlan" && this.changePlanOptions()}
              {view === "payment" && this.paymentOptions()}
              {view === "pause" || view === "pauseSuggestion"
                ? this.pauseOptions()
                : null}
              {view === "cancel" && this.cancelOptions()}
              {view === "faq" && this.faqOptions()}
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  client: state.client,
});

export default withLocalize(connect(mapStateToProps)(SoothePassMembershipView));
